import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

export default function FixedGrid({ children }) {
  return <Container>{children}</Container>;
}

FixedGrid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
};
